(() => {
  const svgNS = 'http://www.w3.org/2000/svg';
  const node = (name, attributes = {}) => {
    const element = document.createElementNS(svgNS, name);
    Object.entries(attributes).forEach(([key, value]) => element.setAttribute(key, value));
    return element;
  };

  const drawChart = (svg) => {
    const values = (svg.dataset.points || '').split(',').map(Number).filter(Number.isFinite);
    if (!values.length) return;
    const width = 640;
    const height = 330;
    const left = 54;
    const right = 18;
    const top = 18;
    const bottom = 43;
    const plotWidth = width - left - right;
    const plotHeight = height - top - bottom;
    const accent = getComputedStyle(svg.closest('[data-atlas-expectations]')).getPropertyValue('--atlas-expect-accent').trim() || '#e72b43';

    svg.replaceChildren();
    for (let index = 0; index < 5; index += 1) {
      const y = top + (plotHeight / 4) * index;
      svg.append(node('line', { x1: left, y1: y, x2: width - right, y2: y, stroke: '#555', 'stroke-width': 1 }));
    }
    svg.append(node('line', { x1: left, y1: top, x2: left, y2: height - bottom, stroke: '#fff', 'stroke-width': 3 }));
    svg.append(node('line', { x1: left, y1: height - bottom, x2: width - right, y2: height - bottom, stroke: '#fff', 'stroke-width': 3 }));

    for (let week = 1; week <= 13; week += 1) {
      const label = node('text', { x: left + ((week - 1) / 12) * plotWidth, y: height - 17, fill: '#fff', 'font-size': 13, 'text-anchor': 'middle' });
      label.textContent = week;
      svg.append(label);
    }

    const coordinates = values.map((value, index) => {
      const x = left + (index / 12) * plotWidth;
      const y = top + (1 - Math.max(0, Math.min(100, value)) / 100) * plotHeight;
      return [x, y];
    });
    const path = node('polyline', { points: coordinates.map((point) => point.join(',')).join(' '), fill: 'none', stroke: accent, 'stroke-width': 4, 'stroke-linecap': 'round', 'stroke-linejoin': 'round' });
    svg.append(path);
    coordinates.forEach(([x, y]) => svg.append(node('circle', { cx: x, cy: y, r: 7, fill: accent })));
  };

  const initialize = (root) => {
    if (!root || root.dataset.atlasExpectReady === 'true') return;
    const buttons = [...root.querySelectorAll('[data-atlas-expect-button]')];
    const panels = [...root.querySelectorAll('[data-atlas-expect-panel]')];
    root.querySelectorAll('[data-atlas-expect-chart]').forEach(drawChart);

    const activate = (id, focus = false) => {
      buttons.forEach((button) => {
        const active = button.dataset.atlasExpectButton === id;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', String(active));
        button.tabIndex = active ? 0 : -1;
        if (active && focus) button.focus();
      });
      panels.forEach((panel) => {
        const active = panel.dataset.atlasExpectPanel === id;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
    };

    buttons.forEach((button, index) => {
      button.addEventListener('click', () => activate(button.dataset.atlasExpectButton));
      button.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
        if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = buttons.length - 1;
        activate(buttons[next].dataset.atlasExpectButton, true);
      });
    });

    root.dataset.atlasExpectReady = 'true';
    if (buttons[0]) activate(buttons[0].dataset.atlasExpectButton);
  };

  const initializeAll = (scope = document) => scope.querySelectorAll('[data-atlas-expectations]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
  else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
